.auto-complete-container {
    position: relative;
    text-align: left;

    .search-action-container {
        z-index: 11;
    }

    .search-results {
        @extend %list-reset;
        position: absolute;
        top: 58.5px;
        left: -30px;
        right: 0;
        max-height: calc(100vh - 72px) !important;
        background: $core-neutral-100;
        box-shadow: $heavy-drop-shadow;
        overflow-y: auto;
        z-index: 10;
        width: 100vw;
        box-shadow: none !important;

        .result-item {
            user-select: none;
            font-size: 18px;
            font-weight: 400;
            line-height: 1.5;
            padding: 16px 24px;
            border-bottom: 2px solid $core-neutral-300;
            background-color: $core-neutral-100;

            & > a {
                color: $core-neutral-900;
                display: flex;
                align-items: left;
                flex-direction: column;
                justify-content: space-between;
                text-decoration: none;
            }

            .contents {
                margin-right: 16px;

                .tags {
                    display: flex;
                    align-items: center;
                    flex-direction: row;
                    color: $core-neutral-700;
                    margin-bottom: 4px;

                    .icon.icon-dot-darkgrey {
                        margin-left: 8px;
                        margin-right: 8px;
                    }
                }
            }

            .secondary-button.small {
                flex-shrink: 0;
                padding-left: 16px;
                padding-right: 16px;
            }

            &:hover {
                background-color: $colour-weight-lt;
            }

            &.selected {
                background-color: $colour-weight-lt;
            }

            .icon-search-error {
                margin-top: 2px;
            }
        }
    }

    @include min(768px) {
        .search-results {
            max-height: calc(var(--vh, 1vh) * 100 - 250px) !important;
            top: 38px;
            left: 0;
            width: initial;
            box-shadow: $search-drop-shadow !important;
        }
    }

    // @include breakpoint(desktop_l) {
    //     .search-results .result-item .title-text {
    //         @include fluid-type($mobile-point, $large-desktop-point, 18px, 20px);
    //     }
    // }

    // @include breakpoint(tablet) {
    //     .search-results .result-item {
    //         .contents {
    //             margin-right: 0;
    //         }

    //         .secondary-button.small {
    //             display: none;
    //         }
    //     }
    // }
}